import { observer } from "mobx-react-lite";
import React, {useContext} from "react";

import Select from "../components/Select";
import { ApiContext } from "../contexts";
import { HouseType,IconName } from "../types";
import Icon from "./Icon";
import TextInput from "./TextInput";

const HouseFilters = observer(
  (props: {
    inlineLabels?: boolean;
    beds: number;
    living: number;
    baths: number;
    cars: number;
    searchText?: string;
    onClickBeds: (val: number) => void;
    onClickLiving: (val: number) => void;
    onClickBaths: (val: number) => void;
    onClickCars: (val: number) => void;
    onSearchChange?: (val: string) => void; // If not provided, the search bar will be hidden
    onScreenKeyboard: boolean;
  }) => {
    const apiContext = useContext(ApiContext);

    const getLotWidthOptions = () => {
      const options = [{ key: "", value: "Any" }];
      for (const width of apiContext.lotWidthsResults) {
        options.push({
          key: width,
          value: `${width}m`,
        });
      }
      return options;
    };

    const getSeriesOptions = () => {
      const options = [{ key: "", value: "Any" }];
      for (const series of apiContext.seriesOptions) {
        if(apiContext.houseType === null 
          || (apiContext.houseType === HouseType.SINGLE_STORY && series.storeys === 1)
          || (apiContext.houseType === HouseType.DOUBLE_STORY && series.storeys === 2)
          || (apiContext.houseType === HouseType.ACREAGE && series.acreage)
        ){
          options.push({
            key: series.id,
            value: series.title,
          });
        }
      }
      return options;
    };

    return (
      <div
        className={`pyht-house-filters state-nsw ${
          props.inlineLabels ? "inline-labels" : ""
        } ${props.onSearchChange ? "with-search" : "without-search"}`}
      >
        <div className={"filter-section beds"}>
          <span className={"filters-label"}>Beds</span>
          <div className={"filter-btns"}>
            {[3, 4, 5].map((num) => {
              return (
                <button
                  key={num}
                  className={`btn btn-secondary ${
                    props.beds === num ? "active" : ""
                  }`}
                  onClick={() => props.onClickBeds(num)}
                >
                  {num}
                </button>
              );
            })}
          </div>
        </div>
        <div className={"filter-section living"}>
          <span className={"filters-label"}>Living</span>
          <div className={"filter-btns"}>
            {[1, 2, 3].map((num) => {
              return (
                <button
                  key={num}
                  className={`btn btn-secondary ${
                    props.living === num ? "active" : ""
                  }`}
                  onClick={() => props.onClickLiving(num)}
                >
                  {num}
                </button>
              );
            })}
          </div>
        </div>
        <div className={"filter-section baths"}>
          <span className={"filters-label"}>Baths</span>
          <div className={"filter-btns"}>
            {[2, 2.5].map((num) => {
              return (
                <button
                  key={num}
                  className={`btn btn-secondary ${
                    props.baths === num ? "active" : ""
                  }`}
                  onClick={() => props.onClickBaths(num)}
                >
                  {num}
                </button>
              );
            })}
          </div>
        </div>
        <div className={"filter-section cars"}>
          <span className={"filters-label"}>Cars</span>
          <div className={"filter-btns"}>
            {[1, 2].map((num) => {
              return (
                <button
                  key={num}
                  className={`btn btn-secondary ${
                    props.cars === num ? "active" : ""
                  }`}
                  onClick={() => props.onClickCars(num)}
                >
                  {num}
                </button>
              );
            })}
          </div>
        </div>
        <div className={"filter-section width"}>
          <span className={"filters-label"}>Lot Width</span>
          <Select
            id={"select-lot-width"}
            options={getLotWidthOptions()}
            value={apiContext.lotWidth}
            onChange={(val) => apiContext.setLotWidth(val)}
          />
        </div>
        <div className={"filter-section series"}>
          <span className={"filters-label"}>Series</span>
          <Select
            id={"select-series"}
            options={getSeriesOptions()}
            value={apiContext.series ? apiContext.series.id : ""}
            onChange={(val) => apiContext.setSeries(val)}
          />
        </div>
        {props.onSearchChange && (
          <div className={"filter-section search"}>
            <div className={"filter-text"}>
              <Icon name={IconName.SEARCH} />
              <TextInput
                placeholder={"SEARCH BY KEYWORD"}
                value={props.searchText}
                onChange={(val) =>
                  props.onSearchChange && props.onSearchChange(val)
                }
                onScreenKeyboard={props.onScreenKeyboard}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default HouseFilters;
